export default "__VITE_ASSET__B93S06lS__"